import { Rectangle } from 'recharts';

import {
    BAR_CHART_MIN_HEIGHT_PX,
    scaleBarHeightFromFloor,
} from '../../model/lib/barChartHelpers';

import type { MouseEventHandler } from 'react';

interface BarBackground {
    height?: number;
}

interface ReportWidgetFloorBarProps {
    x?: number;
    y?: number;
    width?: number;
    height?: number;
    fill?: string;
    radius?: number | [number, number, number, number];
    background?: BarBackground;
    cursor?: string;
    className?: string;
    onClick?: MouseEventHandler<SVGElement>;
    onMouseEnter?: MouseEventHandler<SVGElement>;
    onMouseLeave?: MouseEventHandler<SVGElement>;
    onMouseMove?: MouseEventHandler<SVGElement>;
}

export const ReportWidgetFloorBar = ({
    x = 0,
    y = 0,
    width = 0,
    height = 0,
    background,
    ...rest
}: ReportWidgetFloorBarProps) => {
    const plotHeight =
        typeof background?.height === 'number' ? background.height : 0;

    const scaledHeight = scaleBarHeightFromFloor({
        linearHeight: height,
        plotHeight,
        minHeight: BAR_CHART_MIN_HEIGHT_PX,
    });

    return (
        <Rectangle
            {...rest}
            x={x}
            y={y + height - scaledHeight}
            width={width}
            height={scaledHeight}
        />
    );
};
